export default [
  {
    path: '/admin/item-overtimes',
    name: 'item-overtime',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/item-overtime/index.vue')
  }
]
